import React, { useEffect, useState } from "react";
import ObtieneDatosCookies from "../obtieneDatosCookiesUsuario";
import { useNavigate } from "react-router-dom";
import Listado from "../NCadetes/Listado";
import ParteList from "../Cuerpo/ParteList";
import HuellasLector from "./HuellasLector";
import AvisosInternosPorFecha from "../NCadetes/AvisosInternosPorFecha";

const Logistica = () => {
  const Usuario = ObtieneDatosCookies();
  const navigate = useNavigate();

  // Aquí se obtiene la fecha de hoy de manera automática
  const fechaHoy = new Date().toLocaleDateString("en-CA"); // Formato YYYY-MM-DD

  const [fecha, setFecha] = useState(fechaHoy); // Inicializar con la fecha de hoy
  const [sede, setSede] = useState("");
  const [muestraHuellas, setMuestraHuellas] = useState(false)



  useEffect(() => {
    if (!Usuario.id) {
      alert("Acceso no Autorizado");
      window.location.href = './';
    }
  }, [Usuario]);

  useEffect(() => {
    // Este efecto se ejecuta solo una vez cuando se carga el componente
    setFecha(fechaHoy); // Asignar la fecha actual por defecto
  }, []); // Solo cuando el componente se monta

  return (
    <>
      <div style={{ textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center" }}>
        <h3 style={{backgroundColor:"#456",color:"#eff",width:"100%"}}>Division Logistica</h3>
        <button className="btn btn-warning" onClick={() => navigate('/usuarioLogueado')}>
          Volver
        </button>

        <input
          type="date"
          value={fecha}
          onChange={(e) => setFecha(e.target.value)}
          style={{ width: "250px", borderRadius: "5px", padding: "15px", textAlign: "center", fontSize: "20px" }}
        />

        {Usuario.sedeID == 1 && (
          <>
            <AvisosInternosPorFecha fecha={fecha} sede={"Rosario"} />
            <AvisosInternosPorFecha fecha={fecha} sede={"Recreo"} />
          </>
        )}

        {Usuario.sedeID == 2 && <AvisosInternosPorFecha fecha={fecha} sede={"Rosario"} />}
        {Usuario.sedeID == 3 && <AvisosInternosPorFecha fecha={fecha} sede={"Recreo"} />}
        
        <button onClick={() => setMuestraHuellas(!muestraHuellas)}>Registro de Huellas</button>
        {muestraHuellas && <HuellasLector />}
        <ParteList />
        <Listado />
      </div>
    </>
  );
};

export default Logistica;
